var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(!_vm.$route.meta.hiddenHeaderContent ? 'margin: -24px -24px 0px;' : null)},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"page-header-index-wide"},[_vm._t("default",function(){return [(_vm.multiTab)?_c('keep-alive',[_c('router-view',{ref:"content"})],1):_c('router-view',{ref:"content"})]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }